import { TextFieldProps } from '@mui/material';

export const commonInputProps: Partial<TextFieldProps> = {
  margin: 'none',
  fullWidth: true,
  size: 'small',
  variant: 'outlined',
};
